import { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import InvoiceStatusModalDialog from './InvoiceStatusModalDialog';

InvoiceStatusModalButton.propTypes = {
  id: PropTypes.number,
  total: PropTypes.number,
  vendor: PropTypes.string,
  bookingVendorStatus: PropTypes.string,
  inline: PropTypes.bool,
};

const getColor = (status) => {
  switch (status) {
    case 'Paid': return 'primary';
    case 'Posted': return 'info';
    case 'Reversed': return 'error';
    case 'Selected': return 'warning';
    case 'Partially Paid': return 'warning';
    default: return '#000000';
  }
};

const getTooltip = (status) => {
  switch (status) {
    case 'Paid': return 'Paid';
    case 'Posted': return 'Posted';
    case 'Reversed': return 'Reversed';
    case 'Selected': return 'Selected for payment';
    case 'Partially Paid': return 'Partially Paid';
    default: return 'No Data';
  }
};

export default function InvoiceStatusModalButton({ id, total, vendor, bookingVendorStatus, inline }) {
  const [open, setOpen] = useState(false);

  return <>
    <Tooltip title={getTooltip(bookingVendorStatus)}>
      <IconButton
        onClick={() => setOpen(true)}
        color={getColor(bookingVendorStatus)}
        {...(inline && { disableRipple: true, component: 'span', size: 'small' })}
        sx={{ ...(inline && { p: 0, m: 0, minWidth: 0, minHeight: 0, borderRadius: 0, lineHeight: 1, verticalAlign: 'middle' }) }}
      >
        <RequestQuoteIcon />
      </IconButton>
    </Tooltip>

    {open && <InvoiceStatusModalDialog id={id} total={total} vendor={vendor} bookingVendorStatus={bookingVendorStatus} close={() => setOpen(false)} />}
  </>;
}